import React from "react";

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // 更新 state 以触发降级 UI
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // 这里可以上报错误日志
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // 降级 UI
      return <div>出了点问题，请稍后再试。11</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
